import { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Divider,
  Button,
  Text,
  Loading,
} from "@nextui-org/react";
import SearchCard from "./SearchCard";
import { AiFillCalendar, AiFillCloseCircle } from "react-icons/ai";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import PrintCard from "./PrintCard";
import moment from "moment";
import { DatePicker, DatePickerInput } from "@mantine/dates";
import { useDisclosure } from "@mantine/hooks";
import { Collapse, Group } from "@mantine/core";

const PrintModal = (props) => {
  //Manage search input value
  const [inputValue, setInputValue] = useState("");
  //Manage search results (placeholder until redux is implemented!)
  const [allData, setAllData] = useState([]);
  const [result, setResult] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState([
    moment().startOf("month").subtract(60, "days"),
    moment().endOf("month"),
  ]);
  const [error, setError] = useState(false);
  const [opened, { open, close }] = useDisclosure();

  //input change handler
  const onChangeHandler = (event) => {
    setInputValue(event.target.value);
  };

  //useEffect fetchAll
  useEffect(() => {
    setError(false);
    setLoading(true);
    fetch(
      `https://sca-token-api.vercel.app/orders?start=${moment(dateFilter[0])
        .startOf("day")
        .toISOString()}&end=${moment(dateFilter[1]).endOf("day").toISOString()}`
    )
      .then((res) => {
        if (!res.ok) {
          setError(true);
        }
        return res.json();
      })
      .then((data) => {
        const newData = data
          .map((doc) => {
            return doc.products
              .map((subDoc) => {
                return subDoc.codes.map((sbDoc) => {
                  return {
                    ...subDoc,
                    codes: sbDoc,
                    date: doc.date,
                    orderName: doc.name,
                    orderId: doc._id,
                  };
                });
              })
              .flat();
          })
          .flat();
        // console.log(newData);
        setAllData(newData);
        setResult(newData);
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
      });
  }, [dateFilter]);

  //Run useEffect after waiting for 500 ms to prevent request spam
  useEffect(() => {
    const timeoutId = setTimeout(() => filters(), 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dateFilter, inputValue, allData]);

  const filters = () => {
    if (allData.length > 0) {
      setLoading(true);
      let copy = [...allData];

      if (inputValue !== "") {
        const regex = new RegExp(inputValue, "i");
        copy = copy.filter((doc) => {
          return (
            regex.test(doc.name) ||
            regex.test(doc.orderName) ||
            regex.test(doc.codes) ||
            regex.test(doc?.date)
          );
        });
      }

      setResult(copy);
      setLoading(false);
    }
  };

  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      aria-label="Search"
      fullScreen
      scroll
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Modal.Header
        css={{
          p: "10px",
          mw: "550px",
          w: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="searchActions">
          <Input
            type="text"
            css={{ w: "100%", mr: "5px" }}
            placeholder="Start searching here..."
            aria-label="Search Input"
            onChange={onChangeHandler}
            clearable
            animated={false}
          />
          <Group wrap="nowrap" gap={4}>
            <Button
              auto
              color="success"
              onClick={() => {
                if (opened) {
                  close();
                } else {
                  open();
                }
              }}
            >
              <AiFillCalendar />
            </Button>
            <Button auto color="error" onClick={props.onClose}>
              <AiFillCloseCircle />
            </Button>
          </Group>
        </div>
      </Modal.Header>
      <Divider />
      <Modal.Body
        css={{
          p: "10px",
          // mw: "550px",
          w: "100%",
          height: "100%",
        }}
      >
        <div className="searchResult">
          <Collapse in={opened}>
            <Group w="100%" justify="center">
              <DatePicker
                variant="filled"
                type="range"
                value={dateFilter}
                onChange={(v) => {
                  setDateFilter(v);
                }}
                allowSingleDateInRange
              />
            </Group>
          </Collapse>
          {error && (
            <Text
              css={{
                br: "20px",
                py: "5px",
                px: "10px",
                bgColor: "$red100",
                textAlign: "center",
              }}
              color="$red700"
              size="14px"
            >
              An error occured while trying to retrieve data! Please go back and
              try again.
            </Text>
          )}
          {loading ? (
            <Loading type="spinner" />
          ) : (
            <AutoSizer className="autoSizer">
              {({ width, height }) => (
                <FixedSizeList
                  height={height}
                  itemSize={90}
                  width={width}
                  itemCount={result.length}
                  itemData={{ result }}
                  className="reactWindow"
                  // style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}
                >
                  {Row}
                </FixedSizeList>
              )}
            </AutoSizer>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PrintModal;

const Row = ({ data, index, style }) => {
  const doc = data?.result[index];

  return (
    <div style={style} className="linkCards">
      <PrintCard onClose={() => console.log("yada")} doc={doc} key={index} />
    </div>
  );
};
